/* eslint max-classes-per-file: 0 */

import {
  LkPublication as Data,
  LkPublicationCollection as Collection,
} from '@/typings/api/Publication'
import { TransformerDAll } from '@/store/createCrudModule/TransformerData'
import { LkPublicPublicationsApi as Api } from '@/api/resources/public'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, TransformerData, Adapter } = Fabric<Data, Collection>()

export class LkPublicPublicationsTransformerParams extends TransformerParams {
  protected defaultParams = ['slug', 'topic_slug'];

  protected per_page = 'pageSize';
}

export class LkPublicPublicationsTransformerData extends TransformerData {
  protected readonly transformerAll: TransformerDAll = (response) => ({
    ...response,
    // @ts-ignore TODO:
    data: response.publications,
  });
}

export class LkPublicPublicationsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new LkPublicPublicationsTransformerParams();

  public readonly transformerData = new LkPublicPublicationsTransformerData();
}
